"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventDropdownFromClosing = exports.ZIndexWrapper = exports.StyledDropdownLi = exports.OptionGroupName = exports.DropdownTriggerStyledButton = exports.DropdownMetaItemStyle = exports.DropdownListLabel = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _constants = require("../../form/constants");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _constants2 = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DropdownListLabelStyle = (0, _context.styledWithTheme)('li')(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    backgroundColor: selectors.color('neutral0'),
    borderBottom: "".concat((0, _utils.px)(_constants2.DIVIDER_WIDTH), " solid ").concat(selectors.color(_constants2.BORDER_COLOR)),
    color: selectors.color(_constants2.LABEL_TEXT_COLOR),
    fontFamily: selectors.fontFamily('primary'),
    padding: (0, _utils.px)(selectors.space(_constants2.ITEM_PADDING))
  };
});

var DropdownListLabel = function DropdownListLabel(props) {
  return (0, _core.jsx)(DropdownListLabelStyle, (0, _extends2.default)({
    role: "presentation",
    onMouseUpCapture: preventDropdownFromClosing
  }, props));
};

exports.DropdownListLabel = DropdownListLabel;
var OptionGroupNameStyle = (0, _context.styledWithTheme)('li')(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    backgroundColor: selectors.color('neutral0'),
    borderBottom: "".concat((0, _utils.px)(_constants2.DIVIDER_WIDTH), " solid ").concat(selectors.color(_constants2.BORDER_COLOR)),
    color: selectors.color(_constants2.LABEL_TEXT_COLOR),
    fontFamily: selectors.fontFamily('primary'),
    padding: (0, _utils.px)(selectors.space(_constants2.ITEM_PADDING)),
    lineHeight: 1.5
  };
});

var OptionGroupName = function OptionGroupName(props) {
  return (0, _core.jsx)(OptionGroupNameStyle, (0, _extends2.default)({
    onMouseUpCapture: preventDropdownFromClosing
  }, props));
};

exports.OptionGroupName = OptionGroupName;
var ZIndexWrapper = (0, _context.styledWithTheme)('div')(function (_ref3) {
  var theme = _ref3.theme,
      isOpen = _ref3.isOpen,
      isAlwaysOpened = _ref3.isAlwaysOpened;
  return _objectSpread({
    zIndex: isOpen ? theme.selectors.zIndex('dropdown') : 0
  }, isAlwaysOpened && {
    width: '100%',
    padding: (0, _utils.px)(theme.selectors.space('S200'))
  });
});
exports.ZIndexWrapper = ZIndexWrapper;
var StyledDropdownLi = (0, _context.styledWithTheme)('li')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      selectors = _ref4$theme.selectors,
      isInHighContrast = _ref4$theme.isInHighContrast,
      isHighlighted = _ref4.isHighlighted,
      isSearchable = _ref4.isSearchable,
      isSelectedNavigation = _ref4.isSelectedNavigation,
      withCustomSelectionOptions = _ref4.withCustomSelectionOptions,
      isGroupItem = _ref4.isGroupItem;
  var backgroundColor;

  if (isSelectedNavigation) {
    backgroundColor = isHighlighted ? _constants2.NAVIGATION_HIGHLIGHT_COLOR : _constants2.NAVIGATION_SELECTED_COLOR;
  } else {
    backgroundColor = isHighlighted ? _constants2.HIGHLIGHT_COLOR : 'neutral0';
  }

  var borderColor = selectors.color(_constants2.BORDER_COLOR);
  var topShadow = "inset 0px 2px 0px -1px ".concat(borderColor);
  var bottomShadow = "inset 0px -2px 0px -1px ".concat(borderColor);
  var highlightedStyles = isSearchable ? {
    boxShadow: "".concat(bottomShadow, ", ").concat(topShadow),
    ':last-of-type': {
      boxShadow: topShadow
    }
  } : {
    ':not(:first-of-type):not(:last-of-type)': {
      boxShadow: "".concat(bottomShadow, ", ").concat(topShadow)
    },
    ':first-of-type:not(:last-of-type)': {
      boxShadow: bottomShadow
    },
    ':last-of-type:not(:first-of-type)': {
      boxShadow: isGroupItem ? "".concat(bottomShadow, ", ").concat(topShadow) : topShadow
    }
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    fontFamily: selectors.fontFamily('primary'),
    fontSize: selectors.fontSize(_constants2.FONT_SIZE),
    lineHeight: selectors.lineHeight(_constants2.FONT_SIZE),
    color: selectors.color(_constants2.TEXT_COLOR),
    backgroundColor: selectors.color(backgroundColor),
    cursor: 'pointer',
    padding: (0, _utils.px)(selectors.space(_constants2.ITEM_PADDING)),
    position: 'relative'
  }, withCustomSelectionOptions ? {
    paddingLeft: (0, _utils.px)(selectors.space(_constants2.ITEM_WITH_GROUPING_LEFT_PADDING))
  } : {}), isHighlighted ? highlightedStyles : {}), isHighlighted && isInHighContrast ? {
    outlineStyle: 'solid',
    outlineOffset: '-2px'
  } : {}), {}, {
    ':not(:last-of-type)': {
      borderBottom: "".concat((0, _utils.px)(_constants2.DIVIDER_WIDTH), " solid ").concat(borderColor)
    }
  });
});
exports.StyledDropdownLi = StyledDropdownLi;
var DropdownMetaItemStyle = (0, _context.styledWithTheme)(_layout.View)(function (_ref5) {
  var selectors = _ref5.theme.selectors,
      shouldHaveNoBorder = _ref5.shouldHaveNoBorder,
      borderPosition = _ref5.borderPosition;
  return _objectSpread({
    fontFamily: selectors.fontFamily('primary'),
    fontSize: selectors.fontSize(_constants2.FONT_SIZE),
    lineHeight: selectors.lineHeight(_constants2.FONT_SIZE),
    color: selectors.color(_constants2.TEXT_COLOR),
    backgroundColor: selectors.color('neutral0'),
    padding: (0, _utils.px)(selectors.space(_constants2.ITEM_PADDING))
  }, !shouldHaveNoBorder && (0, _defineProperty2.default)({}, borderPosition === _interfaces.DropdownItemBorderPosition.Bottom ? 'borderBottom' : 'borderTop', "".concat(_constants2.DIVIDER_WIDTH, "px solid ").concat(selectors.color(_constants2.BORDER_COLOR))));
});
exports.DropdownMetaItemStyle = DropdownMetaItemStyle;
var DropdownTriggerStyledButton = (0, _context.styledWithTheme)('button')(function (_ref7) {
  var theme = _ref7.theme,
      hasAriaDisabled = _ref7.hasAriaDisabled,
      disabled = _ref7.disabled,
      error = _ref7.error,
      warning = _ref7.warning;
  var isDisabled = disabled || hasAriaDisabled;
  var isError = isDisabled ? false : error;
  var isWarning = isDisabled ? false : warning;
  var borderColor = isError ? _constants2.BORDER_COLOR_ERROR : isWarning ? _constants2.BORDER_COLOR_WARNING : _constants2.BORDER_COLOR;
  var borderColorHover = isError ? _constants2.BORDER_COLOR_ERROR_HOVER : isWarning ? _constants2.BORDER_COLOR_WARNING_HOVER : _constants2.BORDER_COLOR_HOVER;
  var borderColorFocus = isError ? _constants2.BORDER_COLOR_ERROR_FOCUS : isWarning ? _constants2.BORDER_COLOR_WARNING_FOCUS : _constants2.BORDER_COLOR_FOCUS;
  var hoverStyles = isDisabled ? {} : {
    borderColor: theme.selectors.color(borderColorHover)
  };
  return {
    display: 'block',
    appearance: 'none',
    WebkitAppearance: 'none',
    padding: (0, _utils.px)(_constants.INPUT_PADDING_DEFAULT),
    margin: 0,
    width: '100%',
    backgroundColor: theme.selectors.color(isDisabled ? _constants2.BACKGROUND_COLOR_DISABLED : 'neutral0'),
    border: "".concat(_constants2.BORDER_WIDTH, "px solid ").concat(theme.selectors.color(borderColor)),
    outline: 'none',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    fontFamily: theme.selectors.fontFamily('primary'),
    fontSize: theme.selectors.fontSize(_constants2.FONT_SIZE),
    lineHeight: theme.selectors.lineHeight(_constants2.FONT_SIZE),
    color: theme.selectors.color(isDisabled ? _constants2.TEXT_COLOR_DISABLED : _constants2.TEXT_COLOR),
    textAlign: 'start',
    wordBreak: 'break-word',
    ':hover': _objectSpread({}, hoverStyles),
    ':focus': {
      borderColor: theme.selectors.color(borderColorFocus),
      outline: "".concat(_constants2.BORDER_WIDTH, "px solid ").concat(theme.selectors.color(borderColorFocus)),
      outlineOffset: "".concat(_constants2.BORDER_WIDTH, "px")
    }
  };
});
exports.DropdownTriggerStyledButton = DropdownTriggerStyledButton;

var preventDropdownFromClosing = function preventDropdownFromClosing(event) {
  event.stopPropagation();
};

exports.preventDropdownFromClosing = preventDropdownFromClosing;